import { adminPath } from '@/core/utils/env.utils';

export const ENDPOINTS = {
  LOGIN: adminPath('/auth/login'),
  REFRESH: adminPath('/auth/refresh'),
  LOGOUT: adminPath('/auth/logout'),
  ME: adminPath('/auth/me'),
} as const;